import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getProductsBySkus } from 'b2b-apps/shop/product/redux/products/tile/selectors';
import { ProductTileType } from 'b2b-apps/shop/product/redux/products/tile/types';

type UseProductTilesReturnType = Record<string, RemoteRecord<ProductTileType>>;

const useProductTilesData = (skus: string[]): UseProductTilesReturnType => useSelector(
  state => getProductsBySkus(state, skus),
);

export { useProductTilesData };
export type { UseProductTilesReturnType };
